<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :max-width="$vuetify.breakpoint.smAndDown ? undefined : '1400px'"
    persistent
    scrollable
  >
    <v-card :style="$vuetify.breakpoint.smAndDown ? 'border-radius: 0;' : ''">
      <v-card-title
        class="d-flex justify-space-between align-center py-4 px-6"
        style="position: sticky; top: 0; background: white; z-index: 2; border-bottom: 1px solid #e0e0e0;"
      >
        <span style="font-family: 'montserrat-bold'; font-size: 24px; color: black;">
          Detalle de pago
        </span>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <PaymentDetail :key="sPaymentId" :s-payment-id="sPaymentId" :as-dialog="true" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PaymentDetail from "@/views/History/PaymentDetail.vue";

export default {
  name: "PaymentDetailDialog",
  components: {
    PaymentDetail,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    sPaymentId: {
      type: String,
      default: null,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    close() {
      this.show = false;
    },
  },
};
</script>
